import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=270462c0&scoped=true&lang=pug&"
import script from "./Fields.vue?vue&type=script&lang=js&"
export * from "./Fields.vue?vue&type=script&lang=js&"
import style0 from "./Fields.vue?vue&type=style&index=0&id=270462c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270462c0",
  null
  
)

export default component.exports